module.exports = __webpack_public_path__ + "img/icono-addCita.98b3fb88.svg";